import { ChecklistItemNoteRecord } from "models/view-models/checklist-item-notes/checklist-item-note-record";
import ServiceHookFactory from "utilities/services/service-hook-factory";

export interface ChecklistItemNoteResourcePathParams {
    id: number;
}

export interface ChecklistItemNoteQueryParams {}

export interface ChecklistItemNoteCreateParams {
    checklistItemId: number;
    text: string;
}

export interface ChecklistItemNoteUpdateParams {
    text: string;
}

const resourceType = ChecklistItemNoteRecord;
const baseEndpoint = "checklistitemsnotes";
const resourceEndpoint = "checklistitemsnotes/:id";

const ChecklistItemNoteService = {
    useCreate: ServiceHookFactory.useCreateFromPostParams<
        ChecklistItemNoteRecord,
        ChecklistItemNoteCreateParams
    >(resourceType, baseEndpoint),
    useDelete:
        ServiceHookFactory.useDelete<ChecklistItemNoteResourcePathParams>(
            resourceEndpoint
        ),
    useUpdate: ServiceHookFactory.useUpdateFromPutParams<
        ChecklistItemNoteRecord,
        ChecklistItemNoteUpdateParams,
        ChecklistItemNoteResourcePathParams
    >(resourceType, resourceEndpoint),
};

export default ChecklistItemNoteService;
